export default "/institutions/chase.svg";